export interface OverlayStyle {
  title: string;
  sharpCharts2TypeId: string;
  sharpCharts2Args: string;
}

export const OVERLAY_STYLE_AUTO: OverlayStyle = {
  title: '- Auto -',
  sharpCharts2TypeId: '',
  sharpCharts2Args: ''
};

export const OVERLAY_STYLE_SOLID: OverlayStyle = {
  title: 'Solid',
  sharpCharts2TypeId: 'line',
  sharpCharts2Args: '1.5,solid'
};

export const OVERLAY_STYLE_SOLID_THIN: OverlayStyle = {
  title: 'Solid (thin)',
  sharpCharts2TypeId: 'line',
  sharpCharts2Args: '1.0,solid'
};

export const OVERLAY_STYLE_SOLID_THICK: OverlayStyle = {
  title: 'Solid (thick)',
  sharpCharts2TypeId: 'line',
  sharpCharts2Args: '2.0,solid'
};

export const OVERLAY_STYLE_DASHED: OverlayStyle = {
  title: 'Dashed',
  sharpCharts2TypeId: 'line',
  sharpCharts2Args: '1.5,dash2'
};

export const OVERLAY_STYLE_DASHED_THIN: OverlayStyle = {
  title: 'Dashed (thin)',
  sharpCharts2TypeId: 'line',
  sharpCharts2Args: '1.0,dash2'
};

export const OVERLAY_STYLE_DASHED_THICK: OverlayStyle = {
  title: 'Dashed (thick)',
  sharpCharts2TypeId: 'line',
  sharpCharts2Args: '2.0,dash3'
};

export const OVERLAY_STYLE_HISTOGRAM: OverlayStyle = {
  title: 'Histogram',
  sharpCharts2TypeId: 'hist',
  sharpCharts2Args: '0.0'
};

export const OVERLAY_STYLE_AREA: OverlayStyle = {
  title: 'Area',
  sharpCharts2TypeId: 'area',
  sharpCharts2Args: '0.0,0.0'
};

export const OVERLAY_STYLE_DOTS: OverlayStyle = {
  title: 'Dots',
  sharpCharts2TypeId: 'dots',
  sharpCharts2Args: ''
};

export const DEFAULT_OVERLAY_STYLE: OverlayStyle = OVERLAY_STYLE_AUTO;

export const OVERLAY_STYLES_ARRAY: OverlayStyle[] = [
  OVERLAY_STYLE_AUTO,
  OVERLAY_STYLE_SOLID,
  OVERLAY_STYLE_SOLID_THIN,
  OVERLAY_STYLE_SOLID_THICK,
  OVERLAY_STYLE_DASHED,
  OVERLAY_STYLE_DASHED_THIN,
  OVERLAY_STYLE_DASHED_THICK,
  OVERLAY_STYLE_HISTOGRAM,
  OVERLAY_STYLE_AREA,
  OVERLAY_STYLE_DOTS
];

export function getOverlayStyleObjFromOverlayStyleTitle(overlayStyleTitle: string): OverlayStyle {
  return OVERLAY_STYLES_ARRAY.find(option => option.title === overlayStyleTitle) ?? DEFAULT_OVERLAY_STYLE;
}
